import React from 'react';
import MapContainer from '../components/locations/MapContainer';
import LocationList from '../components/locations/LocationList';
import { MapsProvider } from '../contexts/MapsContext';

export default function LocationsPage() {
  return (
    <div className="min-h-screen bg-gray-900 pt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">Find a BTM Near You</h1>
          <p className="text-xl text-gray-300">
            Locate our secure Bitcoin ATMs across Texas. All machines are available 24/7.
          </p>
        </div>
        <MapsProvider>
          <MapContainer />
        </MapsProvider>
        <div className="mt-12">
          <h2 className="text-2xl font-semibold text-white mb-6">Available Locations</h2>
          <LocationList />
        </div>
      </div>
    </div>
  );
}